/* Module for wide screen ux */

import * as types from '../mutation-types'

const state = {
    wideScreenSelectedConid: '', // stores the last selected conid for WideModeRightCol.vue in wide QD, portfolio and watchlist views
    wideLayout: false // stores whether to show in wide mode, relies on cp setting and whether window width > 1400
}

const mutations = {
    [types.SET_WIDE_SCREEN_SELECTED_CONID](state, conid) {
        state.wideScreenSelectedConid = conid;
    },

    [types.SET_WIDE_LAYOUT](state, val) {
        state.wideLayout = val;
    }
}

const actions = {
    setWideScreenSelectedConid({ commit }, { conid }) {
        commit(types.SET_WIDE_SCREEN_SELECTED_CONID, conid);
    },

    setWideLayout({ commit }, { val }) {
        commit(types.SET_WIDE_LAYOUT, val);
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
